import { useMainStore } from '@/core/store/main.ts';
import { storeToRefs } from 'pinia';
import {
  ComputedRef, onMounted, ref,
} from 'vue';
import { useVoiceoverStore } from '../VoiceoverAudioPlayer/store.ts';
import { useBackgroundAudioPlayerStore } from '@/shared/components/players/BackgroundAudioPlayer/store.ts';

export interface UsePresentationModeProps {
  closeCurtains: ComputedRef<(props: { duration?: number }) => Promise<boolean>>;
  openCurtains: ComputedRef<(props: { duration?: number }) => Promise<boolean>>;
  playVideo: ComputedRef<() => Promise<boolean>>;
  stopVideo: ComputedRef<() => Promise<boolean>>;
  onStop: () => void;
}

// if no one has tapped the screen during TIMER_DELAY, then we start the promo video
const TIMER_DELAY = 30000;

export const usePresentationMode = (props: UsePresentationModeProps) => {
  const { mode } = storeToRefs(useMainStore());

  let timer: number | undefined = undefined;

  const promoVideoEnabled = ref(false);

  const curtainsEnabled = ref(false);

  const { soundEnabled } = storeToRefs(useBackgroundAudioPlayerStore());

  const { voiceoverEnabled } = storeToRefs(useVoiceoverStore());

  const hundleTouch = () => {
    if (curtainsEnabled.value) {
      if (promoVideoEnabled.value) {
        stopPromoVideo();
      } else {
        props.openCurtains.value({
        }).then(() => {
          curtainsEnabled.value = false;
          unmuteSounds();
        });
      }
    }

    startTimer();
  };

  const muteSounds = () => {
    soundEnabled.value = false;

    voiceoverEnabled.value = false;
  };

  const unmuteSounds = () => {
    soundEnabled.value = true;

    voiceoverEnabled.value = true;
  };

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = window.setTimeout(() => {
      curtainsEnabled.value = true;

      muteSounds();

      props.closeCurtains.value({
      }).then(() => {
        playPromoVideo();
      });
    }, TIMER_DELAY);
  };

  const playPromoVideo = () => {
    promoVideoEnabled.value = true;
    setTimeout(() => {
      props.playVideo.value();
    });
  };

  const stopPromoVideo = () => {
    props.onStop();
    props.stopVideo.value().then(() => {
      promoVideoEnabled.value = false;
      props.openCurtains.value({
      }).then(() => {
        curtainsEnabled.value = false;
        unmuteSounds();
      });
    });
  };

  onMounted(() => {
    if (mode.value === 'presentation-with-promo') {
      window.addEventListener('touchstart', hundleTouch);

      startTimer();
    }
  });

  return {
    promoVideoEnabled,
    curtainsEnabled,
  };
};
